import { TableContainer } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/system';

export const VioltionsReportContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  width: '100%',
  backgroundColor: theme.palette.background.hover,
  borderRadius: theme.spacing(1),
  height: 'calc(100% - 70px)',
}));

export const ReportsViolationsTableContainer = styled(TableContainer)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  gap: theme.spacing(1),
  padding: theme.spacing(1),
  backgroundColor: theme.palette.background.default,
}));

export const StyledBox = styled(TableContainer)(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const ReportsViolationsContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '95%',
  gap: theme.spacing(2),
  width: '100%',
  borderRadius: theme.spacing(1),
}));
